module.exports = __webpack_public_path__ + "static/FAIRR-0402552c11a70146f4d95c6c47faa3c5.jpg";